import IndexVM from './index-vm';

export default {
  init() {
    const el = document.getElementById('coursework_index');
    const data = JSON.parse(document.getElementById('coursework_listing_json').value);

    ko.applyBindingsWithValidation(new IndexVM(data), el);
  }
};

